import React from 'react';

const StudiesList = ({ data }) => {
  return (
    <div className='studies-bg-wrapper'>
        <section className="studies-section">
        {data.studiesData.map((study, index) => (
            <div key={index} className="study-card">
            <div className="study-card-inner">
                <h3 className="study-title">{study.title}</h3>
                <p className="study-source">
                <strong>Source:</strong> {study.source}
                </p>
                <ul className="study-highlights">
                {study.highlights.map((point, i) => (
                    <li key={i}>{point}</li>
                ))}
                </ul>
                <a
                className="study-link"
                href={study.link}
                target="_blank"
                rel="noopener noreferrer"
                >
                Read Full Study
                </a>
            </div>
            </div>
        ))}
        </section>
    </div>
  );
};

export default StudiesList;
